export default __webpack_public_path__ + "static/media/kweblio.18b01321.png";